import { Box, Button, Collapse, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NestedMultivalueProps } from "./NestedMultivalue";
import { FoodsIcon } from "@foodpilot/foods";
import { Fragment } from "react/jsx-runtime";
import { MultivaluePropertyHandler } from "../../../context/hooks/useMultivalueProperty";
import { usePropertyContext } from "../../../context/usePropertyContext";
import { NoElementsForMulti } from "../NoElements";
import { MultiElementsGroup } from "./MultiElementsGroup";

type NestedMultiInnerProps = NestedMultivalueProps & {
    multivalueHandler: MultivaluePropertyHandler;
    existingElements: number;
    isOpen: boolean;
    setIsOpen: (v: boolean) => void;
};
export const NestedMultiInner = (props: NestedMultiInnerProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { multivalueHandler, property, level, existingElements, isOpen, setIsOpen } = props;
    const { elementsGroup, addElementsGroup, markAsNotApplicable, deleteElementsGroup } = multivalueHandler;

    const { canEdit } = usePropertyContext();

    if (existingElements === 0) {
        return (
            <Stack
                sx={{
                    // This is used as a way to work-around the "slide effect" of the collapse
                    // And having the "gap" from the parent
                    paddingTop: theme.spacing(2),
                }}
            >
                <NoElementsForMulti
                    property={property}
                    onAdd={() => {
                        // At default state, ensure it is closed WHEN initiated WITH items.
                        // However, when it does has items WHEN adding items, make sure it's opened.
                        setIsOpen(true);
                        addElementsGroup();
                    }}
                    onNotApplicable={markAsNotApplicable}
                />
            </Stack>
        );
    }

    return (
        <Collapse in={isOpen}>
            <Stack
                alignItems="flex-start"
                gap={theme.spacing(3)}
                sx={{
                    // This is used as a way to work-around the "slide effect" of the collapse
                    // And having the "gap" from the parent
                    paddingTop: theme.spacing(2),
                }}
            >
                <Stack
                    width={"100%"}
                    gap={theme.spacing(3)}
                    divider={<Box sx={{ borderTop: `1px solid ${theme.custom.grey[600]}` }} />}
                >
                    {elementsGroup.map((elementGroup, idx) => {
                        const itemNb = idx + 1;
                        return (
                            <Fragment key={`multivalue-group-${elementGroup.position}`}>
                                <MultiElementsGroup
                                    elementGroup={elementGroup}
                                    itemNb={itemNb}
                                    deleteElement={deleteElementsGroup}
                                    level={level}
                                    showSubscore={props.showSubscore}
                                />
                            </Fragment>
                        );
                    })}
                </Stack>
                {canEdit && (
                    <Button
                        variant="text"
                        color="primary"
                        startIcon={<FoodsIcon size={2} icon={"plus"} />}
                        onClick={addElementsGroup}
                    >
                        {t("ajouter_un_element")}
                    </Button>
                )}
            </Stack>
        </Collapse>
    );
};
